import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

//@ts-ignore
import styles from './video.module.css'

const useVideoQuery = () => {
    const data = useStaticQuery(graphql`
        query VideoQuery {
            allContentfulLink(filter: {buttonText: {eq: "videolink"}}){
                        nodes {
                            buttonText
                            url
                        }
            }
        }
    `);
    // console.log({data});
    return data?.allContentfulLink?.nodes?.[0];
}
export const VideoSection = () => {
    const data = useVideoQuery();
    // console.log({data});
    return (
        <section className={styles.pageSection}>
            <span className={styles.sectionHeaderText}>How it works</span>
            <div className={styles.videoContainer}>
                <iframe 
                    src={data?.url}
                    width={"560"}
                    height={"315"}
                    // height={"auto"}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </div>
        </section>
    )
}